import { useContext } from 'react';
import { AlertContext } from './alertProvider';

const useAlertProvider = () => {
  const { alerts, setAlerts } = useContext(AlertContext);
  return { alerts, setAlerts };
};

export default useAlertProvider;
